export {};

declare global {
  interface Window {
    gettext: (str: string) => string;
    ngettext: (singular: string, plural: string, n: number) => string;
    npgettext: (
      context: string,
      singular: string,
      plural: string,
      n: number,
    ) => string;
    interpolate: (
      fmt: string,
      obj: Record<string, unknown> | unknown[],
      named?: boolean,
    ) => string;
  }
}

if (typeof window !== "undefined") {
  if (typeof window.gettext === "undefined") {
    window.gettext = (str: string): string => str;
  }

  if (typeof window.ngettext === "undefined") {
    window.ngettext = (singular: string, plural: string, n: number): string => {
      return n > 1 ? plural : singular;
    };
  }

  if (typeof window.npgettext === "undefined") {
    window.npgettext = (
      _context: string,
      singular: string,
      plural: string,
      n: number,
    ): string => {
      return n > 1 ? plural : singular;
    };
  }

  if (typeof window.interpolate === "undefined") {
    window.interpolate = function (
      fmt: string,
      obj: Record<string, unknown> | unknown[],
      named?: boolean,
    ): string {
      if (named) {
        const values =
          obj && typeof obj === "object" && !Array.isArray(obj)
            ? obj
            : ({} as Record<string, unknown>);

        return fmt.replace(/%\(([^)]+)\)s/g, (_match, key: string) => {
          const value = Object.prototype.hasOwnProperty.call(values, key)
            ? values[key]
            : "";
          return String(value);
        });
      }

      const arr = Array.isArray(obj) ? obj.slice() : [obj];
      let idx = 0;

      return fmt.replace(/%s/g, () => {
        const value = idx < arr.length ? arr[idx++] : "";
        return String(value);
      });
    };
  }
}
